export const BASE_INVENTORY_MOVEMENTS = {
  MOVEMENT_REASON: 'Venta',
  MOVEMENT_TYPE: 'Salida',
};

export const BASE_CREATE_INCOME = {
  VENTA: 'Venta',
  PAGADO: 'Pagado',
  PENALIZACION: 'Pago tardio',
};

export const BASE_CREATE_DEBT = {
  DEBIT_ESTATUS: 'Adeudo Pendiente de pago',
  PENALIZACION: 'Pago tardio venta',
  DESCUENTO: 'Pronto pago venta',
};

export const CREDENTIAL_PUBLIC = {
  CREDENTIAL: 'PUBLICO',
};

export const BASE_CREATE_NEW_INVENTORY = {
  MOVEMENT_REASON: 'Compra',
  MOVEMENT_TYPE: 'Entrada',
};
export const BASE_CANCELLATION_ORDER = {
  MOVEMENT_REASON: 'Devolución',
  MOVEMENT_TYPE: 'Entrada',
};
